export enum GameErrorCodes {
  // ConnectionError - desc: connection is lost, aka: Session Interupted
  ConnectionError = 1011,
  // Reconnect - note: game handles reconnect case
  Reconnect = 1012,
  // GameIsOpen - desc: game opened in another device/browser
  GameIsOpen = 1013,
  // NotEnoughMoney - desc: insufficient funds to play
  NotEnoughMoney = 1014,
  // PlayerLimitExceeded - desc: player limit exceeded
  PlayerLimitExceeded = 1016,
  // GeneralError - desc: general error
  GeneralError = 1017,
  // SessionExpired - desc: session expired
  SessionExpired = 1018,
  // OperatorError - desc: errors sent from operator
  OperatorError = 1019,
  // todo: add player blocked error: 1020
}
